import {
  DiscountTax,
  TotalTaxExcludingDicountTax,
  TotalTax,
  positive
} from "../../../api/payment/Utilities";
import { calculator } from "./../../../api/services/PriceCalculatorService";
import { couponCalculator } from "./../../../api/services/CouponCalculatorService";
import {
  findSameItem,
  calcTotalPrice
} from "../../../api/helpers/shoppingCartHelper";
import {
  priceTriggerDiscountsSum,
  rollIntoPriceSum
} from "../../../api/helpers/priceTriggerHelpers";
export const state = {
  cartItems: [],
  currentstore: null,
  deliveryFee: 0,
  isDelivery: false,
  coupons: [],
  priceTriggerOutcomes: [],
  forceUpdate: false
};

export const mutations = {
  setIsDelivery(state, isDelivery) {
    state.isDelivery = isDelivery;
  },
  setStore(state, payload) {
    state.currentstore = payload;
  },
  setDeliveryFee(state, payload) {
    state.deliveryFee = payload;
  },
  Add_ProductItem(
    state,
    { item, quantity, ProductCategoryIDs, ProductTagIDs, modifiers }
  ) {
    let now = new Date();
    const records = state.cartItems.filter(element => element.id == item.id);
    let same = true;
    let find = null;
    if (records.length > 0) {
      find = findSameItem(item, modifiers, records);
      if (!find) {
        same = false;
      }
    } else {
      same = false;
    }
    if (!same) {
      state.cartItems.push({
        ...item,
        modifiers: modifiers,
        quantity,
        ProductCategoryIDs,
        ProductTagIDs,
        created: now.toUTCString()
      });
    } else {
      find.quantity += quantity;
      // if (find.modifiers) {
      //   find.modifiers.map(md => {
      //       md.quantity += modifiers.filter(m => m.ID === md.ID)[0].quantity;
      //   });
      // }

      find.created = new Date().toUTCString();
    }
  },
  Set_Items(state, items) {
    if (items) {
      state.cartItems = items;
    }
  },
  REMOVE_CART_ITEM(state, { item }) {
    const record = state.cartItems.find(element => element.id == item.id);
    state.cartItems.splice(state.cartItems.indexOf(record), 1);
  },
  UpdateQuantity(state, { item, quantity }) {
    const records = state.cartItems.filter(element => element.id == item.id);
    let same = true;
    let find = null;
    if (records.length > 0) {
      find = findSameItem(item, item.modifiers, records);
      if (!find) {
        same = false;
      }
      //
      if (same) {
        //let now = new Date();
        find.quantity = quantity;
        //record.created = now.toUTCString();
        if (quantity == 0) {
          state.cartItems.splice(state.cartItems.indexOf(find), 1);
        }
      }
    }
  },
  add_coupon_to_Cart(state, coupon) {
    if (
      coupon &&
      state.coupons.find(cpn => cpn.CouponCode == coupon.CouponCode)
    )
      alert("The Coupon is Duplicated");
    else state.coupons.push(coupon);
  },
  Set_Coupon_Items(state, coupons) {
    state.coupons = coupons;
  },
  remove_coupon_from_Cart(state, couponCode) {
    const record = state.coupons.find(
      element => element.CouponCode == couponCode
    );
    state.coupons.splice(state.coupons.indexOf(record), 1);
  },

  setTriggerCheckOutPage(state, paylod) {
    state.TriggerCheckOutPage = paylod;
  },
  setPriceTriggerOutcomes(state, payload) {
    state.priceTriggerOutcomes = payload;
  },
  confirmRollInto(state, payload) {
    var pt = null;
    if (payload.orderId) {
      pt = state.priceTriggerOutcomes.find(
        pt => pt.ID == payload.id && pt.order == payload.orderId
      );
    } else {
      pt = state.priceTriggerOutcomes.find(pt => pt.ID == payload.id);
    }
    if (pt) {
      pt.selectedRollIntos = [
        {
          index: payload.index ? payload.index : 0,
          selectedModifiers: payload.modifiers,
          isConfirmed: payload.modifiers.length > 0
        }
      ];
    }
    state.forceUpdate = !state.forceUpdate;
  },
  confirmRollIntos(state, payload) {
    var pt = null;
    if (payload.orderId) {
      pt = state.priceTriggerOutcomes.find(
        pt => pt.ID == payload.id && pt.order == payload.orderId
      );
    } else {
      pt = state.priceTriggerOutcomes.find(pt => pt.ID == payload.id);
    }
    pt.selectedRollIntos = payload.rollIntos.map((s, index) => {
      return {
        index: index,
        selectedModifiers: s.modifiers,
        isConfirmed: s.modifiers.length > 0
      };
    });
    state.forceUpdate = !state.forceUpdate;
  }
};

export const actions = {
  clearCart: ({ commit }) => {
    commit("Set_Items", []);
    commit("Set_Coupon_Items", []);
  },
  clearCoupon: ({ commit }) => {
    commit("Set_Coupon_Items", []);
  },
  addCouponToCart: ({ commit }, coupon) => {
    commit("add_coupon_to_Cart", coupon);
  },
  removeCouponfromCart: ({ commit }, coupon) => {
    commit("remove_coupon_from_Cart", coupon);
  },
  applyPriceTriggers({ commit, getters }) {
    commit("setPriceTriggerOutcomes", [...getters.getPriceTriggerOutcomes]);
  }
};

export const getters = {
  getIsDelivery: state => {
    return state.isDelivery;
  },
  cartItems: state => {
    let copy = [...state.cartItems];
    return copy.sort((a, b) => {
      return new Date(b.created) - new Date(a.created);
    });
  },
  costlyCartItems: state => {
    let copy = [...state.cartItems.filter(p => !p.reedemptionRule)];
    return copy.sort((a, b) => {
      return new Date(b.created) - new Date(a.created);
    });
  },
  cartTotalQuantity: state => {
    let copy = [...state.cartItems];
    let totalQuantity = 0;
    copy.forEach(element => {
      totalQuantity += Number(element.quantity);
    });
    return totalQuantity;
  },
  cartValue: state => {
    let res = 0;
    res = calculator.calcCartPrice(state.cartItems);
    var rollintoSum = rollIntoPriceSum(state.priceTriggerOutcomes);
    return positive(res + rollintoSum + (state.forceUpdate ? 0 : 0));
  },
  reedemptionValue: state => {
    var value = calculator.calcCartPrice(
      state.cartItems.filter(p => p.reedemptionRule)
    );
    return value;
  },
  reedemptionLocalUsedPoints: state => {
    var points = 0;
    state.cartItems
      .filter(p => p.reedemptionRule)
      .forEach(cartItem => {
        points += cartItem.reedemptionRule.Point;
      });
    return points;
  },
  reedemptionPoints: (state, getters) => {
    // var points = 0;
    // if (getters.dbuser && getters.dbuser.RewardPoints && withUserRewards)
    //   points = getters.dbuser.RewardPoints;
    // state.cartItems
    //   .filter(p => !p.reedemptionRule)
    //   .forEach(cartItem => {
    //     points += cartItem.RewardPoint * cartItem.quantity;
    //   });
    // return points;
    if (getters.dbuser && getters.dbuser.RewardPoints)
      return getters.dbuser.RewardPoints;
    else return 0;
  },
  getredemptionRewardPoints: state => {
    var points = 0;
    state.cartItems
      .filter(p => !p.reedemptionRule)
      .forEach(cartItem => {
        points += cartItem.RewardPoint * cartItem.quantity;
      });
    return points;
  },
  currentstore(state) {
    return state.currentstore;
  },
  deliveryFee(state) {
    return positive(state.deliveryFee);
  },
  totaltaxExcludingDicountTax(state, getters) {
    return positive(
      TotalTaxExcludingDicountTax(
        state.cartItems,
        getters.cartValue,
        getters.discount
      )
    );
  },
  totaltax(state, getters) {
    return positive(
      TotalTax(
        state.cartItems,
        getters.cartValue,
        getters.discount,
        getters.getSurchargeHolidayValidTax
      )
    );
  },
  discountTax(state, getters) {
    return positive(
      DiscountTax(
        TotalTaxExcludingDicountTax(state.cartItems),
        getters.cartValue,
        getters.discount
      )
    );
  },
  discountExcludingTax(state, getters) {
    return positive(getters.discount - getters.discountTax);
  },
  discount(state, getters) {
    var result =
      couponCalculator.calcAllCoupons(state.coupons, state.cartItems) +
      priceTriggerDiscountsSum(getters.getPriceTriggerOutcomes) +
      (state.forceUpdate ? 0 : 0);
    return result;
  },
  used_coupons: state => {
    couponCalculator.calcAllCoupons(state.coupons, state.cartItems);
    return couponCalculator.used_Coupons;
  },
  getTotalPrice(state, getters) {
    return (
      calcTotalPrice(getters.cartValue, state.deliveryFee, getters.discount) +
      getters.getSurchargeAmount
    );
  },
  priceTriggerOutcomes(state) {
    return state.priceTriggerOutcomes;
  },
  coupons: state => {
    return state.coupons;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
